import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"
import _imports_0 from '../../public/images/error.svg'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "startsida" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  class: "spalt content",
  id: "startvy"
}
const _hoisted_5 = { class: "title" }
const _hoisted_6 = {
  key: 0,
  class: "errormsg",
  tabindex: "-1",
  role: "alert"
}
const _hoisted_7 = ["aria-busy"]
const _hoisted_8 = {
  key: 0,
  class: "laddar-container"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "errormsg",
  role: "alert"
}
const _hoisted_11 = { class: "errormsg_content" }
const _hoisted_12 = { tabindex: "-1" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  class: "globalMessage",
  href: "#orgnummerFalt"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  class: "globalMessage",
  href: "#kodFalt"
}
const _hoisted_17 = { class: "form-container" }
const _hoisted_18 = { class: "form-row" }
const _hoisted_19 = { class: "form-row" }

import { Form } from 'vee-validate';
import * as Yup from 'yup';
import TextInput from '@/components/partials/TextInput.vue';
import { useStore } from '@/store';
import { kontrolleraKod } from "@/api";
import router from '@/router';
import { orgnummerRegex } from '@/validation'
import LaddarSymbol from '@/components/partials/LaddarSymbol.vue';

import i18n from "../i18n";

export default /*@__PURE__*/_defineComponent({
  __name: 'Startsida',
  setup(__props) {

const store = useStore();

const visaLaddarSymbol = (): boolean => {
	return store.state.vantarPaResponse;
}

const visaFelmeddelande = (): boolean => {
	return store.state.felmeddelande.length > 0 && !store.state.verifierad;
}

const onSubmit = () => {
	store.state.orgnummer = orgnummerFalt.value.trim();
	store.state.kod = kodFalt.value.trim();
	
	kontrolleraKod(() => {
		router.push("/svara");
	});
};

const rensaBackendError = () => {
	store.aterstall();
}

const onInvalidSubmit = () => {
	const firstEl = document.querySelector('input:invalid');
	if (firstEl) {
		firstEl.focus();
	}
}

const felmeddelandeOrgnummer: string = i18n.global.t("general.errors.fill_registration_number");
const felmeddelandeKod: string = i18n.global.t("general.errors.fill_code");

const schema = Yup.object().shape({
    orgnr: Yup
    .string()
	.trim()
    .required(felmeddelandeOrgnummer)
	.matches(new RegExp(orgnummerRegex), felmeddelandeOrgnummer),
	kod: Yup
    .string()
    .required(felmeddelandeKod)
});


return (_ctx: any,_cache: any) => {
  const _directive_run = _resolveDirective("run")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("main.title")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("general.info_texts.here_you_announce_first_part")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("general.info_texts.here_you_announce_second_part")), 1),
          (visaFelmeddelande())
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[0] || (_cache[0] = _createElementVNode("img", {
                  class: "errormsg_symbol",
                  width: "32",
                  height: "32",
                  src: _imports_0,
                  alt: ""
                }, null, -1)),
                _createElementVNode("p", null, _toDisplayString(_unref(store).state.felmeddelande), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            "aria-live": "polite",
            "aria-busy": visaLaddarSymbol() ? 'true' : 'false'
          }, [
            (visaLaddarSymbol())
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(LaddarSymbol)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_unref(Form), {
                    onSubmit: onSubmit,
                    "validation-schema": _unref(schema),
                    onInvalidSubmit: onInvalidSubmit
                  }, {
                    default: _withCtx(({ errors }) => [
                      (Object.keys(errors).length != 0)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _cache[1] || (_cache[1] = _createElementVNode("img", {
                              class: "errormsg_symbol",
                              width: "32",
                              height: "32",
                              src: _imports_0,
                              alt: ""
                            }, null, -1)),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("h2", _hoisted_12, [
                                (Object.keys(errors).length == 1)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t("general.errors.correct_issue")), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t("general.errors.correct_issues", { count: Object.keys(errors).length.toString()})), 1)
                                    ], 64))
                              ]),
                              _createElementVNode("ul", null, [
                                (errors.orgnr)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                                      _createElementVNode("a", _hoisted_14, _toDisplayString(errors.orgnr), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (errors.kod)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                                      _createElementVNode("a", _hoisted_16, _toDisplayString(errors.kod), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])), [
                            [_directive_run, rensaBackendError()]
                          ])
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(TextInput, {
                            id: "orgnummerFalt",
                            name: "orgnr",
                            type: "text",
                            required: true,
                            label: "Organisationsnummer",
                            mode: "passive",
                            arialabel: "Organisationsnummer, skriv i formatet 6 siffror bindestreck 4 siffror.",
                            helper: "Format: XXXXXX-XXXX",
                            "required-pattern": _unref(orgnummerRegex),
                            "default-value": _unref(store).state.orgnummer
                          }, null, 8, ["required-pattern", "default-value"])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(TextInput, {
                            id: "kodFalt",
                            name: "kod",
                            type: "text",
                            required: true,
                            label: "Kod",
                            mode: "passive",
                            arialabel: "Kod, skriv in koden som kom i brevet",
                            autocomplete: "off",
                            "default-value": _unref(store).state.kod
                          }, null, 8, ["default-value"])
                        ])
                      ]),
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "button-container" }, [
                        _createElementVNode("button", {
                          "aria-label": "Nästa steg",
                          class: "next",
                          type: "submit"
                        }, "Nästa")
                      ], -1))
                    ]),
                    _: 1
                  }, 8, ["validation-schema"])
                ]))
          ], 8, _hoisted_7)
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "spalt intro" }, null, -1))
      ])
    ])
  ]))
}
}

})